import ModalElement from "../../Components/Modal";
import { useEffect, useState } from "react";
import Button from "../../Components/Button";
import { CardGuest } from "../../Components/CardGuest";
import { useGuests } from "../../Providers/Guests";
import { useUser } from "../../Providers/User";
import { Container, SearchBar, GuestList } from "./style";
import GuestsForm from "../../Components/FormRegisterGuests";
import Footer from "../../Components/Footer";
import { ListCardBox } from "../../Components/ListCardBox";

const Guests = () => {
  const { guests, addNewGuest } = useGuests();
  const { admAuth } = useUser();
  const [userInput, setUserInput] = useState("");
  const [filteredGuests, setFilteredGuests] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);


  const onChangeSearch = (e) => {
    setUserInput(e.target.value);
    if (userInput.length > 0) {
      setFilteredGuests(guests.filter((elem) => elem.cpf.includes(userInput)));
    }
  };

  useEffect(() => { }, [guests]);

  const handleModal = () => {
    setModalIsOpen(!modalIsOpen);
  };

  return (
    <Container>
      <SearchBar>
        <input onChange={(e) => onChangeSearch(e)} placeholder="CPF" />
        <Button>Procurar</Button>
      </SearchBar>
      <GuestList>
        <ListCardBox style={{ height: "80%", width: "80%" }}>
          {userInput.length > 0
            ? filteredGuests?.map((el) => (
              <CardGuest
                key={el.id}
                infs={el}
                deleteable={admAuth}
                editable={admAuth}
              />
            ))
            : guests?.map((el) => (
              <CardGuest
                key={el.id}
                infs={el}
                deleteable={admAuth}
                editable={admAuth}
              />
            ))}
        </ListCardBox>
      </GuestList>
      <ModalElement
        className="modal"
        isOpen={modalIsOpen}
        closeModal={handleModal}
      >
        <GuestsForm handleForm={addNewGuest} guests={guests}></GuestsForm>
      </ModalElement>
      <div className="boxButton">
        <Button onClick={handleModal} className="addButton">
          Novo
        </Button>
      </div>
      <div className="footerPosition">
        <Footer />
      </div>
    </Container>
  );
};
export default Guests;
